import { defineStore } from 'pinia';
import { inject } from 'vue';
import { isAimetaBrowser } from '@/utils/platform';

function defaultWebDeviceField(): string {
  return typeof window !== 'undefined' && isAimetaBrowser() ? 'web' : '';
}

export const useUserStore = defineStore({
  id: 'User',
  state: () => ({
    token: localStorage.getItem('token')
      ? JSON.parse(localStorage.getItem('token') || '')
      : '',
    deviceCode: localStorage.getItem('deviceCode')
      ? localStorage.getItem('deviceCode') || ''
      : defaultWebDeviceField(),
    deviceName: localStorage.getItem('deviceName')
      ? localStorage.getItem('deviceName') || ''
      : defaultWebDeviceField(),
    serverUrl: localStorage.getItem('ttsServerUrl')
      ? localStorage.getItem('ttsServerUrl') || ''
      : '',
    // token: 'f93ad72c960f4efc84e2c6521febaaea',
    payType: 1, //(仅当type=sales时有效)支付类型 为空或者1（在点击购买时）是跳转支付页，2是联系客服
    isVip: false,
    isDeveloper: Number(localStorage.getItem('isDeveloper') || 0),
    developerPermissions: localStorage.getItem('developerPermissions')
      ? (JSON.parse(localStorage.getItem('developerPermissions') || '[]') as string[])
      : ([] as string[]),
    tts_token: '', //火山tts token
    tts_appid: '', //火山tts appid
  }),
  getters: {
    GetKnowledgeSrc: (state) => {
      // return import.meta.env.VITE_KNOWLEDGE_PATH + '#/knowledge?adminToken=' + state.token;
      // VITE_KNOWLEDGE_PATH修改为取本地配置
      return '#/knowledge?adminToken=' + state.token;
    },
  },
  actions: {
    setVip(val: any) {
      this.isVip = val;
    },
    setDeveloperProfile(val: any) {
      this.isDeveloper = Number(val?.isDeveloper || 0);
      this.developerPermissions = Array.isArray(val?.permissions)
        ? val.permissions
        : [];
      localStorage.setItem('isDeveloper', String(this.isDeveloper));
      localStorage.setItem('developerPermissions', JSON.stringify(this.developerPermissions));
    },
    setToken(val: any) {
      this.token = val;
    },
    clearToken() {
      this.token = '';
    },
    setDeviceCode(val: any) {
      this.deviceCode = val;
    },
    setDeviceName(val: any) {
      this.deviceName = val;
    },
    setPayType(val: any) {
      this.payType = val;
    },
    setTtsToken(val: any) {
      this.tts_token = val;
    },
    clearTtsToken() {
      this.tts_token = '';
    },
    setTtsUrl(val: any) {
      this.serverUrl = val;
      localStorage.setItem('ttsServerUrl', val);
    },
    clearTtsUrl() {
      this.serverUrl = '';
    },
    setTtsAppid(val: any) {
      this.tts_appid = val;
    },
    clearTtsAppid() {
      this.tts_appid = '';
    },
  },
});
